export default __webpack_public_path__ + "static/media/Clientes_Formato_de_operaciones_detalles.e846e9ea.xlsx";